import { render, staticRenderFns } from "./ActivosTab.vue?vue&type=template&id=651be5dc&scoped=true"
import script from "./ActivosTab.vue?vue&type=script&lang=js"
export * from "./ActivosTab.vue?vue&type=script&lang=js"
import style0 from "./ActivosTab.vue?vue&type=style&index=0&id=651be5dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651be5dc",
  null
  
)

export default component.exports